import axios from "axios";

const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_API_URL
});

export async function getAxesCombinations(params) {
  try {
    const response = await axiosInstance.post(`/cartesian-axis`, params, {
      withCredentials: true
    });
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function getCartesianBom(configId) {
  try {
    const response = await axiosInstance.get(`/cartesian/bom/${configId}`, {
      withCredentials: true
    });
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export async function syncCartesianFiltersDependencies(params) {
  try {
    const response = await axiosInstance.post("/cartesian-dependencies", params);
    return response.data.payload;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
}

export const x = 6;
